module.exports = __webpack_public_path__ + "static/media/bg.38911726.jpg";